document.addEventListener("DOMContentLoaded", function () {
  const colorOptions = document.querySelectorAll(
    '.product-form__input--swatch input[type="radio"]'
  );

  colorOptions.forEach(function (option) {
    option.addEventListener("change", function (event) {
      updateShadesDescription(event.target);
    });
  });

  function updateShadesDescription(target) {
    const { name, dataset } = target;
    const shadesDescription = dataset.shadesDescription; // Retrieve the shades description from the selected radio button

    // Update the shades description display
    const shadesDescriptionElement = document.querySelector(
      `[data-current-shades-value="${name}"]`
    );
    if (shadesDescriptionElement) {
      shadesDescriptionElement.textContent = shadesDescription;
    }
  }

  function updateSelectedValue(text) {
    var selectedVariant = document.getElementById("selected-variant");
    if (selectedVariant) {
      selectedVariant.innerText = text;
    } else {
      console.warn("Element with ID 'selected-variant' not found");
    }
  }

  function updateSelectedShades(shades) {
    var selectedShades = document.getElementById("selected-shades");
    if (selectedShades) {
      selectedShades.innerText = shades;
    } else {
      console.warn("Element with ID 'selected-shades' not found");
    }
  }

  var colorSwatchRadios = document.querySelectorAll(".ShadeSwatch__Radio");
  colorSwatchRadios.forEach(function (radio) {
    radio.addEventListener("change", function (event) {
      if (event.target.checked) {
        var associatedLabel = document.querySelector(
          'label[for="' + event.target.id + '"]'
        );
        if (associatedLabel) {
          var colorName = associatedLabel.getAttribute("data-tooltip");
          console.log("Selected color:", colorName);
          updateSelectedValue(colorName);

          // Directly get shadeText from the clicked radio input's data-shades attribute
          var shadeText = event.target.getAttribute("data-shades");
          if (shadeText) {
            updateSelectedShades(shadeText); // Here, using updateSelectedShades
          } else {
            console.warn("No shades found for color:", colorName);
          }
        } else {
          console.warn("Associated label not found for:", event.target.id);
        }
      }
    });
  });
});
